import JSONAPISerializer from '@ember-data/serializer/json-api';
import { service } from '@ember/service';
import { underscore } from '@ember/string';
import { processMarkdownInTextDelta } from 'scaleflow/utils/convert-markdown-to-text-delta';
import CUSTOM_QUILL_TEMPLATE from 'scaleflow/utils/quill-extenstions/custom-quill-template';

export default class Initiativeerializer extends JSONAPISerializer {
  @service organisation;

  keyForAttribute(attr) {
    return underscore(attr);
  }

  serialize() {
    let json = super.serialize(...arguments);
    json.data.attributes.external_urls = {
      initiative_doc: json.data.attributes?.initiative_doc || '',
      approach: json.data.attributes?.approach || '',
    };

    delete json.data.attributes.initiative_doc;
    delete json.data.attributes.approach;
    delete json.data.attributes.favorite;
    if (!Object.hasOwnProperty.apply(json.data.attributes, ['active'])) {
      json.data.attributes.active = true;
    }

    if (
      json.data.attributes.duration &&
      json.data.attributes.duration?.split(':').length !== 2
    ) {
      const duration = json.data.attributes.duration;
      json.data.attributes.duration = `${duration}:${duration}`;
    }

    if (
      this.initiativeIsNew(json) &&
      this.tenantIsEligibleForCustomTemplate(this.organisation.id)
    ) {
      this.injectSummaryTextDelta(json);
    }
    return json;
  }

  injectSummaryTextDelta(json) {
    json.data.attributes.summary = CUSTOM_QUILL_TEMPLATE;
  }

  initiativeIsNew(json) {
    return !json.data.id;
  }

  tenantIsEligibleForCustomTemplate(organisation_id) {
    return organisation_id === 'samotics';
  }

  normalize(store, model) {
    const { attributes } = model;
    if (!attributes) return super.normalize(...arguments);
    if (typeof attributes.duration === 'object') {
      const duration = attributes.duration?.from ?? '';
      attributes.duration = duration;
    }

    if (typeof attributes.starting_week === 'object') {
      const from = attributes.starting_week?.from ?? '';
      const to = attributes.starting_week?.to ?? '';
      // Only set starting_week if we have valid values
      if (from && to) {
        attributes.starting_week = `${from}:${to}`;
      } else {
        attributes.starting_week = null;
      }
    }

    //remove 'team' relationship from the payload
    const relationships = model?.relationships;
    if (relationships) delete relationships['team'];
    if (relationships) delete relationships['conversations'];
    // Remove goals relationship to work around Ember Data bug #8990
    // which causes "Cannot remove a resource that is not present" errors
    // when goals are already loaded in the store from the Goals page
    if (relationships) delete relationships['goals'];

    return super.normalize(...arguments);
  }

  normalizeResponse(store, primaryModelClass, payload) {
    if (payload?.data?.attributes?.external_urls) {
      payload.data.attributes.initiative_doc =
        payload.data.attributes.external_urls?.initiative_doc || '';
      payload.data.attributes.approach =
        payload.data.attributes.external_urls?.approach || '';
    }
    if (payload?.data?.attributes?.starting_week) {
      const from = payload.data.attributes.starting_week?.from ?? '';
      const to = payload.data.attributes.starting_week?.to ?? '';
      // Only set starting_week if we have valid values
      if (from && to) {
        payload.data.attributes.starting_week = `${from}:${to}`;
      } else {
        payload.data.attributes.starting_week = null;
      }
    }

    if (payload?.data?.attributes?.duration) {
      const duration = payload.data.attributes.duration?.from ?? '';
      payload.data.attributes.duration = duration;
    }

    if (payload?.data?.attributes?.bon_text_delta) {
      payload.data.attributes.bon_text_delta = processMarkdownInTextDelta(
        payload?.data.attributes.bon_text_delta,
      );
    }

    if (payload?.data?.attributes?.summary) {
      payload.data.attributes.summary = processMarkdownInTextDelta(
        payload.data.attributes.summary,
      );
    }

    return super.normalizeResponse(...arguments);
  }

  normalizeFindAllResponse(store, _, payload) {
    payload.data.forEach((item) => {
      this.normalizeResponse(undefined, undefined, { data: { ...item } });
    });
    return super.normalizeFindAllResponse(...arguments);
  }

  normalizeQueryResponse(store, _, payload) {
    payload.data.forEach((item) => {
      this.normalizeResponse(undefined, undefined, { data: { ...item } });
    });
    return super.normalizeFindAllResponse(...arguments);
  }
}
